// @ts-ignore
import { SwiperOptions } from 'swiper';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

export const SliderConfig: SwiperOptions = {
  //  effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 3,
    loop: true,
    spaceBetween: 10,
    coverflowEffect: {
        rotate: 25,
        stretch: 50,
        depth: 100,
        modifier: 1,
        slideShadows: false
    },
    modules: [ Pagination, Navigation],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
    },
    keyboard:{
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true
    },
    mousewheel: {
        sensitivity: 1,
        eventsTarget: ".my"
    },
    breakpoints: {

        320: {
            slidesPerView: 1
        },
        640: {
            slidesPerView: 2.5
        },
        768: {
            slidesPerView: 3.5
        },
        992: {
            slidesPerView: 3,
            slideShadows: 3
        }
    }
};